import { render, staticRenderFns } from "./AccountChannelSettings.vue?vue&type=template&id=9175fafe&scoped=true&"
import script from "./AccountChannelSettings.vue?vue&type=script&lang=js&"
export * from "./AccountChannelSettings.vue?vue&type=script&lang=js&"
import style0 from "./AccountChannelSettings.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AccountChannelSettings.vue?vue&type=style&index=1&id=9175fafe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9175fafe",
  null
  
)

export default component.exports